import React, { useState } from 'react';
import './Lucyrx.css';
import logo from '../logos/LucyRx-Logo.png';


const LucyrxGuides = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="lucyrx-container">
            <img src={logo} alt="LucyRx Logo" className="lucyrx-logo" />

            <h1 className="lucyrx-title">Lucy Rx Guides</h1>

            {/* Link Box */}
            <a href="https://powerforms.docusign.net/af1cabfa-d331-4771-aa2f-3680b2a10ec0?env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&accountId=e6b74557-3473-4b9f-856e-4ebef6b2b3c7" target="_blank" rel="noopener noreferrer" className="lucyrx-box">
                <div className="lucyrx-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="lucyrx-faq-section">
                <h2 className="lucyrx-faq-title">Frequently Asked Questions</h2>
                <div className="lucyrx-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`lucyrx-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="lucyrx-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="lucyrx-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`lucyrx-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LucyrxGuides;